<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:10:20
-->
<template>
  <div class="bidItem">
    <div class="inner">
      <div class="top flex">
        <div class="left">
          {{ (info.bizName && info.bizName.split("")[0]) || "--" }}
        </div>
        <div class="right">
          <div class="bizName">
            {{ `${info.bizName || "--"}/${info.voyageNumber || "--"}` }}
          </div>
          <div class="sgInfo">
            <span class="goodstype">{{ info.goodsType || "--" }}</span>
            <span class="goodsWeight">{{ info.goodsWeight || 0 }}吨</span>
          </div>
        </div>
      </div>
      <!-- <div class="middle">
        <span class="orgin">始</span>
        <span class="tip">始发地：</span>
        <span class="place">{{info.originPlace || '--'}}</span>
        <img class="middleImg" src="../../../../assets/accountant/to.png">
        <span class="des">目</span>
        <span class="tip">目的地：</span>
        <span class="place">{{info.destinationPlace || '--'}}</span>
      </div> -->
      <div class="middle flex">
        <div class="left">
          <div>
            <p class="tip">始发地：</p>
            <p class="place">{{ info.originPlace || "--" }}</p>
          </div>
          <div>
            <p class="tip">目的地：</p>
            <p class="place">{{ info.destinationPlace || "--" }}</p>
          </div>
        </div>
      </div>
      <div class="info">
        <p><span>发布时间：</span>{{ info.createTime || "--" }}</p>
        <p v-if="info.status === 2">
          <span>中标更新时间：</span>{{ info.updateTime || "--" }}
        </p>
        <p v-if="info.status === 2">
          <span>承运单位：</span>{{ info.shipperName || "--" }}
        </p>

        <p v-if="info.status === 2">
          <span>中标单位：</span>{{ info.bidderName || "--" }}
        </p>
        <p v-if="info.status === 2">
          <span>运输单位：</span>{{ info.cargoOwner || "--" }}
        </p>
      </div>
    </div>
    <div class="status">
      <span class="status2" v-if="info.status === 2">已中标</span>
      <span class="status1" @click="changeStatus" v-if="info.status === 1"
        >更新中标</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "bidItem",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          bizName: "HXD",
          cabinType: "1",
          shipperName: null,
          shipperId: null,
          cargoOwner: null,
          cargoOwnerId: null,
          createBy: null,
          createTime: "2022-07-20 17:02:15",
          creater: "何丽娟",
          destinationAddress: null,
          destinationId: null,
          destinationPlace: "九江",
          flag: 1,
          freightPrice: null,
          goodsType: null,
          goodsWeight: 58000,
          id: 193,
          loadDate: null,
          mergeState: null,
          originAddress: null,
          originId: null,
          originPlace: "太仓",
          params: {},
          rangeDays: 0,
          releaseTime: null,
          releaseType: 3,
          remark: null,
          searchValue: null,
          sgid: "2f8316922b9a4e24aff593a5446bfa10",
          showState: 1,
          status: 1,
          tonnage: 0,
          updateBy: null,
          updateTime: null,
          updater: null,
          voyageNumber: "2212",
        };
      },
    },
  },
  data() {
    return {
      tableList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    changeStatus() {
      this.$emit("action", this.info);
    },
  },
};
</script>

<style lang="less" scoped>
.bidItem {
  width: 96%;
  min-height: 200px;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 10px;
  padding: 0 15px;
  .inner {
    padding: 15px 0;
    .top {
      margin-bottom: 13px;
      .left {
        flex: 0 0 40px;
        height: 40px;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        background: #44b1f9;
        border-radius: 6px;
        color: #fff;
        margin-right: 10px;
      }
      .bizName {
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        padding: 2px 0;
        line-height: 16px;
        margin-bottom: 2px;
      }
      .sgInfo {
        span {
          display: inline-block;
          padding: 2px 5px;
          font-size: 12px;
          line-height: 1.1;
        }
        .goodstype {
          margin-right: 10px;
          background: rgba(31, 181, 74, 0.15);
          color: #1fb54a;
        }
        .goodsWeight {
          margin-right: 10px;
          background: rgba(255, 0, 0, 0.15);
          color: #ff0000;
        }
      }
    }
    // .middle{
    //   display: inline-block;
    //   vertical-align: middle;
    //   height: 28px;
    //   background: rgba(68,177,249,0.06);
    //   border-radius: 5px;
    //   line-height: 28px;
    //   padding: 0 5px;
    //   color: #333;
    //   margin-bottom: 15px;
    //   span,img{
    //     display: inline-block;
    //     vertical-align: middle;
    //     font-size: 13px;
    //   }
    //   img{
    //     width: 23px;
    //     margin: 0 15px;
    //   }
    //   .orgin{
    //     width: 16px;
    //     height: 16px;
    //     text-align: center;
    //     font-size: 12px;
    //     line-height: 16px;
    //     background-color: rgba(255,0,0,0.24);
    //     border-radius: 2px;
    //     color: #ff0101;
    //   }
    //   .des{
    //     width: 16px;
    //     height: 16px;
    //     text-align: center;
    //     font-size: 12px;
    //     line-height: 16px;
    //     background-color: rgba(100,198,123,0.24);
    //     border-radius: 2px;
    //     color: #64c67b;
    //   }
    //   .tip{
    //     color: #999;
    //   }

    // }
    .middle {
      vertical-align: middle;
      border-radius: 5px;
      color: #333;
      margin-bottom: 15px;
      align-items: center;
      justify-content: space-between;
      .left {
        background: url("../../../../assets/workOrder/itemLeft.png") left center
          no-repeat;
        background-size: 8px 44px;
        min-height: 44px;
        padding-left: 15px;
        > div:first-child {
          margin-bottom: 6px;
        }
        .tip,
        .place {
          display: inline-block;
          vertical-align: middle;
          font-size: 13px;
          line-height: 28px;
        }
        .tip {
          color: #999;
          margin-right: 5px;
        }
        .place {
          font-weight: bold;
          color: #000;
        }
      }
      .right {
        flex: 0 0 40px;
        text-align: center;
        .rightIcon {
          display: block;
          width: 32px;
          height: 32px;
          margin: 0 auto 6px;
        }
        .rightText {
          font-size: 13px;
          color: #44b1f9;
          font-weight: 500;
        }
      }
    }
    .info {
      p {
        font-size: 13px;
        line-height: 2;
        color: #333;
        span {
          color: #999;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
  }
  .status {
    border-top: 1px solid #eeeeee;
    padding: 15px 0;
    text-align: right;
    .status2 {
      display: inline-block;
      width: 61px;
      height: 26px;
      background: rgba(68, 177, 249, 0.15);
      border: 1px solid #44b1f9;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #44b1f9;
      line-height: 26px;
    }
    .status1 {
      display: inline-block;
      width: 80px;
      height: 26px;
      background: #44b1f9;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 26px;
    }
  }
}
</style>